export function getResumes (state) {
  return state.list
}

export function getAllResumes (state) {
  return state.allResumes
}

export function getResume (state) {
  return state.resume
}

export function getDraftResume (state) {
  return state.draft
}



// WEBPACK FOOTER //
// ./src/vuex/resumes/getters.js